export const mainDescription = 'LoginModal.Timeout.mainDescription';

export const subDescription = 'LoginModal.Timeout.subDescription';
